import request from '@/utils/request'

export function getSHBudgetList(params, isNotify) {
  return request({
    url: '/api/getSHBudgetList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
export function saveSHBudget (params, isNotify) {
  return request({
    url: '/api/saveSHBudget',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetCompList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetCompList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 양식 관련 API 

// 양식 리스트 조회
export function getSHBudgetDivList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetDivList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
// 구분별 항목 조회
export function getSHBudgetDivItemList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetDivItemList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 구분별 항목 조회
export function saveSHBudgetDivItemList (params, isNotify) {
  return request({
    url: '/api/saveSHBudgetDivItemList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}